<template lang="html">
  <div class="draft">
    <router-view v-if="loaded" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      loaded: false,
    };
  },

  computed: {
    ...mapState({
      id: ({ route }) => route.params.id,
      userId: ({ auth }) => auth.user.uid,
    }),
  },

  created() {
    this.load();
  },

  methods: {
    load() {
      this.$store.dispatch('draft/LOAD_DRAFT', this.id)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.$router.push('/drafts');
        });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>
  .draft {
    min-height: 100%;
  }
</style>
